import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

const specialties = [
  { title: 'Erfaring siden 2001' },
  { title: 'Alt i fliser & klinker' },
  { title: 'Professionelle reparationer' },
  { title: 'Lokal forankring i Tønder' }
];

const Specialties = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section className="py-6 bg-slate-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
        >
          {specialties.map((item, index) => (
            <motion.div 
              key={item.title}
              variants={itemVariants}
              className={`
                flex items-center justify-start md:justify-center px-6 py-4 gap-3 border-orange-500/60
                
                /* Desktop: Vertikale linjer mellem elementer */
                ${index < 3 ? 'lg:border-r-2' : ''}
              `}
            >
              <Check className="h-5 w-5 text-white shrink-0" />
              <h3 className="text-white font-bold text-lg text-left md:text-left lg:text-center leading-tight">{item.title}</h3>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Specialties;
